import { render, staticRenderFns } from "./hongguanshuju.vue?vue&type=template&id=d675d71c&"
import script from "./hongguanshuju.vue?vue&type=script&lang=js&"
export * from "./hongguanshuju.vue?vue&type=script&lang=js&"
import style0 from "./hongguanshuju.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports